export function randomString(len, charset) {
  len = len || 32
  charset = charset || "123567890abcdefghijklmnopqrstuvwxyz"
  const charsetLen = charset.length
  let str = ''
  while (str.length < len) str += charset[Math.random() * charsetLen << 0]
  return str
}
